(function(){
  var h = document.querySelector('.mz-header--light-page');
  if (!h || h.dataset.almHeaderBlanc) return; h.dataset.almHeaderBlanc = '1';
  function paint(on){
    h.querySelectorAll('a, span, svg, li, button, div').forEach(function(e){
      if (on) { e.style.setProperty('color', '#ffffff', 'important'); e.style.setProperty('-webkit-text-fill-color', '#ffffff', 'important'); }
      else { e.style.removeProperty('color'); e.style.removeProperty('-webkit-text-fill-color'); }
    });
    h.querySelectorAll('.mz-logo-img, img[class*="logo"]').forEach(function(im){
      if (on) im.style.setProperty('filter', 'none', 'important');
      else im.style.removeProperty('filter');
    });
  }
  var open = false;
  function refresh(){
    if (window.innerWidth <= 900) { if (open) { open = false; paint(false); } return; }
    var o = !!h.querySelector('[aria-expanded\x3d"true"]') || !!h.querySelector('.alm-inav-item--has-panel:hover');
    if (o !== open) { open = o; paint(o); }
  }
  h.querySelectorAll('.alm-inav-item--has-panel').forEach(function(it){
    it.addEventListener('mouseenter', refresh);
    it.addEventListener('mouseleave', function(){ setTimeout(refresh, 60); });
  });
  new MutationObserver(refresh).observe(h, {attributes:true, subtree:true, attributeFilter:['aria-expanded','class']});
})();

(function(){
  if (window.__almPdpRecolor) return; window.__almPdpRecolor = 1;
  function go(){
    document.querySelectorAll('[id*="pageproduirgong"] [class*="mz-alma-label"], [id*="pageproduirgong"] .zf-payment-badge, [id*="pageproduirgong"] [class*="mz-alma-title"], [id*="pageproduirgong"] [class*="mz-alma-sub"], [id*="pageproduirgong"] [class*="mz-alma-info"]').forEach(function(e){ e.style.setProperty("color", "#14110F", "important"); });
    document.querySelectorAll('[id*="pageproduirgong"] [class*="mz-variant-btn"]:not(.alm-dot), [id*="pageproduirgong"] [class*="mz-alma-pill"]').forEach(function(e){
      if (e.classList.contains("active")) { e.style.setProperty("background", "#1A1814", "important"); e.style.setProperty("border-color", "#1A1814", "important"); e.style.setProperty("color", "#ffffff", "important"); var bs = getComputedStyle(e).boxShadow || ""; if (bs.indexOf("176, 118") !== -1 || bs.indexOf("138, 95") !== -1) e.style.setProperty("box-shadow", "0 0 0 2px #1A1814", "important"); }
      else { e.style.removeProperty("background"); e.style.removeProperty("color"); if ((getComputedStyle(e).borderTopColor||"").indexOf("176, 118") !== -1) e.style.setProperty("border-color", "#1A1814", "important"); }
    });
    document.querySelectorAll('.mz-ann, .mz-ann *, [class*="mz-ann-arrow"], [class*="mz-ann-arrow"] *').forEach(function(e){ e.style.setProperty("color", "#ffffff", "important"); e.style.setProperty("-webkit-text-fill-color", "#ffffff", "important"); });
    /* 2026-08-25 — BLOC SUPPRIME : il repeignait EN INLINE les icones du header
       (panier, cloche, loupe, hamburger) sur mobile, a 0/800/2000/4000 ms. C'est ce
       qui les faisait sauter et changer de couleur apres l'affichage.
       Devenu inutile : <style id="alm-hdr-repos-20260825"> dans snippets/alm-early-fiche.liquid
       (donc dans le <head>) pose deja exactement le meme etat, des le premier pixel. */
    document.querySelectorAll('[id*="pageproduirgong"] [class*="mz-variant-btn"]:not(.alm-dot)').forEach(function(e){ e.style.setProperty("border-width", "1px", "important"); e.style.setProperty("outline", "none", "important"); if (!e.classList.contains("active")) e.style.setProperty("box-shadow", "none", "important"); });
    document.querySelectorAll('[class*="mz-x-feat-icon"] svg').forEach(function(sv){ sv.setAttribute("stroke", "#ffffff"); sv.style.setProperty("stroke", "#ffffff", "important"); var ps = sv.querySelectorAll("*"); for (var y = 0; y < ps.length; y++) { ps[y].style.setProperty("stroke", "#ffffff", "important"); } });
    /* 2026-08-25 — BLOC SUPPRIME : il repeignait EN INLINE les icones du header
       (panier, cloche, loupe, hamburger) sur mobile, a 0/800/2000/4000 ms. C'est ce
       qui les faisait sauter et changer de couleur apres l'affichage.
       Devenu inutile : <style id="alm-hdr-repos-20260825"> dans snippets/alm-early-fiche.liquid
       (donc dans le <head>) pose deja exactement le meme etat, des le premier pixel. */
    /* almDotify v3 : classes seulement (le CSS .alm-dot fait le reste, transitions mortes) */
    var ALM_MAP = {"noir":"noir","blanc":"blanc","or":"or","dor\u00e9":"dore","noyer":"noyer","bois clair":"boisclair","travertin beige":"travertinbeige","pierre noire":"pierrenoire","beige":"beige"};
    var ALM_SW = {};
    document.querySelectorAll('[class*="mz-color-swatch-"]').forEach(function(x){ if (x.dataset && x.dataset.value) ALM_SW[String(x.dataset.value).toLowerCase()] = 1; });
    document.querySelectorAll('[id*="pageproduirgong"] [class*="mz-variant-btn"]').forEach(function(e){
      var t = (e.textContent || "").trim().toLowerCase();
      var key = ALM_MAP[t];
      if (!key) return;
      if (!e.getAttribute("aria-label")) e.setAttribute("aria-label", t);
      e.classList.add("alm-dot", "alm-dot--" + key);
      /* Les pastilles couleur maison ne remplacent le bouton texte que si elles sont
         reellement affichees. Sinon on laisse le bouton texte : sans ca le client
         n'a plus aucun choix de couleur sur la fiche. */
      var swVisible = (function(){
        var c = document.querySelector('[class*="mz-color-swatches"]');
        if (!c) return false;
        if (c.closest('.nty-color-hidden')) return false;
        var cs = window.getComputedStyle(c);
        return cs && cs.display !== "none" && cs.visibility !== "hidden";
      })();
      if (ALM_SW[t] && swVisible) e.classList.add("alm-dot--cache");
      else e.classList.remove("alm-dot--cache");
      e.style.removeProperty("background"); e.style.removeProperty("background-color"); e.style.removeProperty("color"); e.style.removeProperty("border-color"); e.style.removeProperty("box-shadow"); e.style.removeProperty("border-width"); e.style.removeProperty("outline");
    });
    /* 2026-08-25 — almEuroApres SUPPRIME : il reecrivait le symbole euro AVANT le
       montant en « montant + euro » dans les noeuds de texte, a 0/800/2000/4000 ms —
       d'ou le prix qui sautait sur les cartes. Devenu inutile : le format de devise de
       la BOUTIQUE a ete corrige le 25/08, les prix sortent deja au bon format. */
    document.querySelectorAll(".almea-lightup__link").forEach(function(e){ e.style.setProperty("color", "#ffffff", "important"); e.style.setProperty("text-decoration-color", "#ffffff", "important"); e.style.setProperty("border-color", "#ffffff", "important"); });
  }
  [0, 800, 2000, 4000].forEach(function(t){ setTimeout(go, t); });
  document.addEventListener("click", function(){ setTimeout(go, 80); }, true);
  var annZone = document.querySelector(".mz-ann");
  if (annZone && annZone.parentElement) {
    var goT = null;
    new MutationObserver(function(){ clearTimeout(goT); goT = setTimeout(go, 120); }).observe(annZone.parentElement, {childList: true, subtree: true});
  }
})();

(function almScrollPhoto(){
  if (window.__almScrollPhoto) return; window.__almScrollPhoto = 1;
  document.addEventListener('click', function(ev){
    if (window.innerWidth > 900) return;
    var btn = ev.target.closest('[class*="mz-variant-btn"]');
    if (!btn) return;
    setTimeout(function(){
      var sc = document.scrollingElement || document.documentElement;
      var start = sc.scrollTop, t0 = performance.now(), dur = Math.min(900, 350 + start * 0.25);
      if (start < 10) return;
      window.__almScrollAnim = t0;
      var stop = function(){ window.__almScrollAnim = null; };
      window.addEventListener('touchstart', stop, {once: true, passive: true});
      window.addEventListener('wheel', stop, {once: true, passive: true});
      function step(now){
        if (window.__almScrollAnim !== t0) return;
        var p = Math.min(1, (now - t0) / dur);
        var e2 = 1 - Math.pow(1 - p, 3);
        sc.scrollTop = Math.round(start * (1 - e2));
        if (p < 1) requestAnimationFrame(step); else window.__almScrollAnim = null;
      }
      requestAnimationFrame(step);
    }, 150);
  }, true);
})();

(function almVariantImage(){
  if (window.__almVarImg) return; window.__almVarImg = 1;
  var data = null;
  function load(cb){
    if (data) return cb();
    fetch(window.location.pathname + '.js').then(function(r){ return r.json(); }).then(function(j){ data = j; cb(); }).catch(function(){});
  }
  function currentVariantId(){
    var u = new URLSearchParams(window.location.search).get('variant');
    if (u) return String(u);
    var inp = document.querySelector('form[action*="/cart/add"] [name="id"]');
    return inp ? String(inp.value) : null;
  }
  var lastId = currentVariantId();
  function swap(){
    var id = currentVariantId();
    if (!id || id === lastId) return;
    lastId = id;
    load(function(){
      var v = null;
      for (var i = 0; i < data.variants.length; i++) { if (String(data.variants[i].id) === id) { v = data.variants[i]; break; } }
      if (!v || !v.featured_image || !v.featured_image.src) return;
      var src = v.featured_image.src;
      var img = document.querySelector('[class*="mz-main-img-wrap"] img');
      if (!img) return;
      var pre = new Image();
      pre.onload = function(){ img.removeAttribute('srcset'); img.removeAttribute('data-srcset'); img.src = src; };
      pre.src = src;
    });
  }
  document.addEventListener('click', function(ev){
    if (!ev.target.closest('[class*="mz-variant-btn"], [class*="mz-color-swatch"]')) return;
    setTimeout(swap, 1250);
  }, true);
})();
